import React from "react";
import { connect } from "react-redux";
import { HashRouter, Route, Routes, Navigate } from "react-router-dom";
import Aboutus from "../pages/Aboutus/Aboutus";
import Covid from "../pages/Covid/Covid";
import SubmitFeedBack from "../pages/FeedBack/SubmitFeedBack";
import Hiring from "../pages/Hiring/Hiring";
import Offer from "../pages/Hiring/Offer";
import Home from "../pages/Home/Home";
import JobDetail3 from "../pages/Jobs/JobDetail3";
import JobDetailStart from "../pages/Jobs/JobDetailStart";
import MyJobs from "../pages/Jobs/MyJobs";
import SafetyWork from "../pages/Jobs/SafetyWork";
import AllNotification from "../pages/Notification/AllNotification";
import MakingPayment from "../pages/Payment/MakingPayment";
import Payment from "../pages/Payment/Payment";
import StorPayment from "../pages/Payment/StorPayment";
import PrivacyPolicy from "../pages/Policy/PrivacyPolicy";
import Support from "../pages/Policy/Support";
import Review from "../pages/Reviews/Review";
import ThankYou from "../pages/Reviews/ThankYou";
import HouseKeepingService from "../pages/Services/HouseKeepingService";
import NursingCareService from "../pages/Services/NursingCareService";
import SchoolSupportService from "../pages/Services/SchoolSupportService";
import SeniorCareService from "../pages/Services/SeniorCareService";
import ServiceDetail from "../pages/Services/ServiceDetail";
import Services from "../pages/Services/Services";
import SpecialNeedService from "../pages/Services/SpecialNeedService";
import Terms from "../pages/Terms";
import Container from "./Container";
import routes from "./routes";

const BasicRoutes = ({ auth, loader }) => {
    return (
        <>
            <HashRouter>
                <Container>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        {routes.map((route) => {
                            if (auth.loggedIn) {
                                if (route.privateRoute) {
                                    return (
                                        <Route
                                            path={route.path}
                                            element={route.element}
                                            key={route.path}
                                        />
                                    );
                                } else {
                                    return (
                                        <Route
                                            key={route.path}
                                            path={route.path}
                                            element={<Navigate to={"/"} />}
                                        />
                                    );
                                }
                            } else {
                                if (!route.privateRoute) {
                                    return (
                                        <Route
                                            path={route.path}
                                            element={route.element}
                                            key={route.path}
                                        />
                                    );
                                } else {
                                    return (
                                        <Route
                                            key={route.path}
                                            path={route.path}
                                            element={
                                                <Navigate to={"/signin"} />
                                            }
                                        />
                                    );
                                }
                            }
                        })}
                        <Route path="about-us" element={<Aboutus />} />

                        <Route path="covid" element={<Covid />} />
                        <Route
                            path="hiring/:service_id/:care_giver_id"
                            element={<Hiring />}
                        />
                        <Route
                            path="house-keeping-service"
                            element={<HouseKeepingService />}
                        />
                        <Route
                            path="nursing-care-service"
                            element={<NursingCareService />}
                        />
                        <Route
                            path="school-support-service"
                            element={<SchoolSupportService />}
                        />
                        <Route
                            path="senior-care-service"
                            element={<SeniorCareService />}
                        />
                        <Route
                            path="special-need-service"
                            element={<SpecialNeedService />}
                        />

                        <Route
                            path="service-detail"
                            element={<ServiceDetail />}
                        />
                        <Route path="service" element={<Services />} />

                        <Route path="offer" element={<Offer />} />

                        <Route
                            path="job-detail-start"
                            element={<JobDetailStart />}
                        />
                        <Route path="order-detail-3" element={<JobDetail3 />} />
                        <Route path="my-jobs" element={<MyJobs />} />
                        <Route path="review/:id" element={<Review />} />
                        <Route path="safety-work" element={<SafetyWork />} />

                        <Route
                            path="notification"
                            element={<AllNotification />}
                        />
                        <Route
                            path="privacy-policy"
                            element={<PrivacyPolicy />}
                        />
                        <Route
                            path="terms-and-conditions"
                            element={<Terms />}
                        />
                        <Route path="support" element={<Support />} />

                        <Route path="payment" element={<Payment />} />
                        <Route
                            path="making-payment"
                            element={<MakingPayment />}
                        />

                        <Route path="stor-payment" element={<StorPayment />} />
                        <Route
                            path="submit-feedBack"
                            element={<SubmitFeedBack />}
                        />
                        <Route path="thankYou" element={<ThankYou />} />
                    </Routes>
                </Container>
            </HashRouter>
            {loader ? <div id="loader" /> : null}
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    loader: state.loader,
});

export default connect(mapStateToProps)(BasicRoutes);
